import React from 'react';
import { useRecoilValue } from 'recoil';
import { isDesktopState, isMobileState } from '../recoil/selectors';
import styles from './HeroCallout.module.scss';

export interface HeroCalloutProps {
  label: string | React.ReactNode;
  inlineStyles?: {
    desktop?: React.CSSProperties;
    tablet?: React.CSSProperties;
    mobile?: React.CSSProperties;
  };
  titleStyles?: React.CSSProperties;
  color?: 'black' | 'white';
  labelColor?: 'black' | 'white';
  orderIndex?: number;
}

export const HeroCallout: React.FC<HeroCalloutProps> = ({ label, labelColor, inlineStyles, titleStyles, orderIndex, color }) => {
  const calloutColor = color ?? 'white';
  const isMobile = useRecoilValue(isMobileState);
  const isDesktop = useRecoilValue(isDesktopState);
  const animationSlideInDelay = 2 + 0.5 * (orderIndex ?? 0);
  const inlineStylesForDevice = isMobile ? inlineStyles?.mobile : !isDesktop && inlineStyles?.tablet ? inlineStyles?.tablet : inlineStyles?.desktop;
  return (
    <div
      className={styles.heroCalloutWrapper}
      style={{ ...inlineStylesForDevice, animation: `slideInFromTop ${animationSlideInDelay}s cubic-bezier(0.5, 0.5, 0.25, 1) 0s 1` }}
    >
      <span className={styles.heroCalloutTitle} style={{ color: labelColor ?? calloutColor, ...titleStyles }}>
        {label}
      </span>

      <span className={styles.heroCalloutCircles} style={{ borderColor: calloutColor }}>
        <span style={{ borderColor: calloutColor }}>
          <span style={{ backgroundColor: calloutColor }} />
        </span>
      </span>
    </div>
  );
};

export default HeroCallout;
